<template>
  <div class="text-15px text-white h-full flex flex-col">
    <div class="head-bg h-36px pl-20px flex items-center mt-10px flex-shrink-0">模型快捷操作</div>
    <div class="h-72px flex justify-between items-center px-20px flex-shrink-0">
      <div class="truncate w-150px">{{ buildingDetail.name }}</div>
      <div>
        <el-button class="round" @click="toggleHide">{{
          isHide ? '取消隐藏' : '周边隐藏'
        }}</el-button>
      </div>
    </div>
    <div class="flex-1 flex flex-col min-h-0">
      <!-- 标题 -->
      <div class="head-bg h-36px pl-20px flex items-center flex-shrink-0">重点区域查看</div>
      <!-- 楼层列表 - 自适应高度 -->
      <div class="flex-1 overflow-auto min-h-0">
        <el-row type="flex" align="middle" class="h-36px table-choosed">
          <el-col :span="8" class="text-center">楼层名称</el-col>
          <el-col :span="8" class="text-center">编码</el-col>
          <el-col :span="8" class="text-center">操作</el-col>
        </el-row>
        <el-row
          type="flex"
          align="middle"
          class="h-36px table-choosed"
          v-for="item in floorList"
          :key="item.id"
        >
          <el-col :span="8" class="truncate text-center" :title="item.name">{{ item.name }}</el-col>
          <el-col :span="8" class="truncate text-center" :title="item.code">{{ item.code }}</el-col>
          <el-col
            :span="8"
            class="truncate cursor-pointer text-center"
            :class="{ 'text-hex-69bcd5': currentFloorId === item.id }"
            @click.native="goFloor(item)"
            >{{ currentFloorId === item.id ? '离开' : '进入' }}</el-col
          >
        </el-row>
      </div>
    </div>
    <!-- <div class="head-bg h-36px pl-20px flex items-center mt-10px">重点区域查看</div>
    <div :class="[currentFloorId === '' ? 'h-[calc(100%-150px)]': 'h-[calc(100%-500px)]']" class="area-box h-[calc(100%-500px)] text-14px text-white overflow-y-auto">
      <el-row type="flex" align="middle" class="h-36px table-choosed">
        <el-col :span="8" class="text-center">楼层名称</el-col>
        <el-col :span="8" class="text-center">编码</el-col>
        <el-col :span="8" class="text-center">操作</el-col>
      </el-row>
      <el-row
        type="flex"
        align="middle"
        class="h-36px table-choosed"
        v-for="item in floorList"
        :key="item.id"
      >
        <el-col :span="8" class="truncate text-center" :title="item.name">{{ item.name }}</el-col>
        <el-col :span="8" class="truncate text-center" :title="item.code">{{ item.code }}</el-col>
        <el-col
          :span="8"
          class="truncate cursor-pointer text-center"
          :class="{'text-hex-69bcd5': currentFloorId === item.id}"
          @click.native="goFloor(item)"
        >{{ currentFloorId === item.id ? '离开' : '进入'}}</el-col>
      </el-row>
    </div> -->
    <!-- 人员及设备列表部分 -->
    <div class="flex-1 flex flex-col min-h-0">
      <div class="head-bg h-36px pl-20px flex items-center mt-10px flex-shrink-0">
        {{ nowFloor }}监控设备
      </div>
      <!-- TableButtonGroup部分 -->
      <div class="h-40px relative flex-shrink-0">
        <div class="absolute top-10px left-0">
          <TableButtonGroup
            :value="AlerValue"
            :list="AlertList"
            @btn-click="(value) => (AlerValue = value)"
          />
        </div>
      </div>
      <!-- 列表内容 - 自适应高度 -->
      <div v-if="AlerValue === '人员'" class="flex-1 overflow-auto min-h-0">
        <el-row
          type="flex"
          align="middle"
          class="h-36px table-choosed"
          v-for="item in personList"
          :key="item.id"
        >
          <el-col :span="16" class="truncate text-center" :title="item.userName">{{
            item.userName
          }}</el-col>
          <el-col
            :span="8"
            class="truncate cursor-pointer text-center"
            @click.native="toPersonInfo(item)"
            >查看</el-col
          >
        </el-row>
      </div>
      <div v-else class="flex-1 overflow-auto min-h-0">
        <el-row
          type="flex"
          align="middle"
          class="h-36px table-choosed"
          v-for="item in cameraList"
          :key="item.id"
        >
          <el-col :span="16" class="truncate text-center" :title="item.name">{{
            item.name
          }}</el-col>
          <el-col
            :span="8"
            class="truncate cursor-pointer text-center"
            @click.native="clickView(item)"
            >查看</el-col
          >
        </el-row>
      </div>
      <!-- 分页器 -->
      <div class="text-right mt-10px">
        <el-pagination
          v-if="AlerValue === '人员'"
          background
          small
          @current-change="getPersonList"
          :current-page.sync="personForm.pageNo"
          layout="slot, prev, jumper, next"
          :page-size.sync="personForm.pageSize"
          :total="personForm.total"
          :pager-count="5"
        >
          <template>
            <div class="inline-block mr-5px">
              <div class="text-15px text-[#fff] flex items-center">
                共
                <span class="text-center text-hex-fbaf3d">{{ personForm.total }}</span
                >条数据
              </div>
            </div>
          </template>
        </el-pagination>
        <el-pagination
          v-else
          background
          small
          @current-change="getCameraList"
          :current-page.sync="cameraForm.pageNo"
          layout="slot, prev, jumper, next"
          :page-size.sync="cameraForm.pageSize"
          :total="cameraForm.total"
          :pager-count="5"
        >
          <template>
            <div class="inline-block mr-5px">
              <div class="text-15px text-[#fff] flex items-center">
                共
                <span class="text-center text-hex-fbaf3d">{{ cameraForm.total }}</span
                >条数据
              </div>
            </div>
          </template>
        </el-pagination>
      </div>
      <videoDialog
        v-if="monitorDetailVisible"
        :show.sync="monitorDetailVisible"
        :code="currentMonitor.code"
        :name="currentMonitor.name"
        :pIid="currentMonitor.pIid"
        :showControlPanel="true"
        :manufacturerCode="currentMonitor.manufacturerCode"
        :daHuaParams="{
          id: currentMonitor.id,
          code: currentMonitor.code,
        }"
      ></videoDialog>
    </div>
  </div>
</template>

<script>
import { BuildingApi, FloorApi } from '@wiz-api/personnel-position'
import { ClipApi, CompositeStateApi } from '@wiz-api/scene-management'
import { IOTDeviceApi } from '@wiz-api/iot-device-management'
import { PersonnelLocationApi } from '@wiz-api/huizhou2'
import { isEmpty, flatten, map, cloneDeep, filter, some, isNil } from 'lodash'
import TableButtonGroup from '@/components/cockpit/TableButtonGroup'
import cloudRender from '../../assets/js/model/index'

const iotDeviceApi = new IOTDeviceApi()
const buildingApi = new BuildingApi()
const floorApi = new FloorApi()
const clipApi = new ClipApi()
const compositeStateApi = new CompositeStateApi()
const personnelLocationApi = new PersonnelLocationApi()

const videoDialog = () => {
  return import('./components/video/videoDialog')
}
export default {
  components: {
    TableButtonGroup,
    videoDialog,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    player: {
      type: Object,
      defalut: null,
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    labelList: {
      type: Array,
      default: () => {
        return []
      },
    },
    allLineList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      buildingDetail: {},
      floorList: [],
      moveTimer: null,
      currentFloorId: '',
      // 剖切区域的信息
      clipDetail: {},
      // 剖切类型
      clipType: {
        box: 0, // 盒子剖切
        singlePanel: 1, // 单面剖切
        doublePanel: 2, // 双面剖切
        ThreePanel: 3, // 三面剖切
      },
      // 打开剖切的方式
      clipDataType: {
        aabb: 0, // 包围盒
        model: 1, // 模型
        node: 2, // node
        item: 3,
        clipData: 4, // 剖切数据
      },
      isHide: false,
      // 组态数组
      configurationArr: [],
      // 传递的labelList
      propLabelList: [],
      // 最初的labelList
      oldLabelList: [],
      // 当前楼层的电子围栏数组
      currentFenceIdList: [],
      // 实时数据集合
      coordinateLocationList: [],
      // 能否调用筛选实时定位接口的标识
      flag: false,
      // 当前楼层
      nowFloor: '',
      // 显示人员还是设备
      AlerValue: '设备',
      AlertList: ['设备'],
      // 当前楼层摄像头
      cameraList: [],
      personList: [],
      cameraForm: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      personForm: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      // 当前楼层人员
      peopleList: [],
      peopleForm: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      // 查看摄像相关
      monitorDetailVisible: false,
      currentMonitor: {},
    }
  },
  computed: {
    buildingId() {
      return this.transferProps.buildingId
    },
  },
  mounted() {
    // 监听实时人员数据更新的事件
    window.addEventListener('setPositionList', this.positionListHandler)
  },
  watch: {
    // 如果切换建筑
    async buildingId() {
      await this.getBuildingDetail()
      await this.moveAngle(this.buildingDetail)
      await this.getFloorList()
      // 如果在进入楼层的时候切换了建筑需要退出剖切状态
      // 并将当前进入的楼层id置为''
      if (!isEmpty(this.currentFloorId)) {
        await cloudRender.Clip.cancelClip(this.player)
        this.currentFloorId = ''
      }
      // 如果上一个建筑的已隐藏组态，需要取消隐藏，并将标志置为false
      if (this.isHide) {
        await this.setVisible(true)
        this.isHide = false
      }
    },
    labelList: {
      immediate: true,
      deep: true,
      handler(value) {
        this.propLabelList = _.cloneDeep(value)
      },
    },
  },
  async created() {
    await this.getBuildingDetail()
    await this.moveAngle(this.buildingDetail)
    await this.getFloorList()
    // await this.getPersonList()
    await this.getCameraList()
  },
  methods: {
    toPersonInfo(row) {
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: 'PersonnelInfo',
            origin: 'tag',
            name: '人员信息',
            originTagName: 'PersonnelList',
          },
          type: 'tags',
          props: {
            personnelId: row.userId,
            tagCode: '',
            isTrajectory: false,
            isFollow: true,
          },
        },
      })
      window.dispatchEvent(openEvent)
    },
    // 获取建筑详情
    async getBuildingDetail() {
      const [err, res] = await buildingApi.get(this.transferProps.buildingId)
      if (!err && !isEmpty(res)) {
        this.buildingDetail = res
      }
    },
    // 移动视角
    async moveAngle(data) {
      if (!isEmpty(data.angleJson)) {
        if (this.moveTimer) clearTimeout(this.moveTimer)
        this.moveTimer = setTimeout(async () => {
          cloudRender.Camera.moveCamera(this.player, 'CameraParam', data.angleJson)
        }, 500)
      }
    },
    // 获取楼层列表
    async getFloorList() {
      const [err, res] = await floorApi.getList({
        sceneId: this.customProps?.sceneId,
        buildingId: this.buildingId,
        skipCount: 0,
        maxResultCount: 1000,
      })
      if (!err && !isEmpty(res)) {
        this.floorList = res.items
      }
    },
    // 获取剖切区域的信息
    async getclipDetail(id) {
      const [err, res] = await clipApi.get(id)
      if (!err && !isEmpty(res)) {
        this.clipDetail = res
      }
    },
    // 查看视频
    clickView(row) {
      this.currentMonitor = row
      this.monitorDetailVisible = true
    },
    // 获取人员列表
    async getPersonList() {
      const params = {
        buildingId: this.buildingId,
        onLineList: this.allLineList,
      }
      if (this.currentFloorId) {
        params.floorId = this.currentFloorId
      }
      const [err, res] = await personnelLocationApi.getFloorPersonInfo({
        body: params,
      })
      if (!err) {
        this.personList = res
      }
    },
    // 获取摄像头列表
    async getCameraList() {
      const [err, res] = await iotDeviceApi.getDeviceWithDetailPageList({
        floorId: this.currentFloorId,
        buildingId: this.buildingId,
        deviceTypeCode: 'Camera',
        keyWord: '',
        manufacturerCode: '',
        status: 1, // 仅看在线
        isPosition: '',
        isMonitorRange: '',
        maxResultCount: this.cameraForm.pageSize,
        skipCount: (this.cameraForm.pageNo - 1) * this.cameraForm.pageSize,
      })
      if (!err && res) {
        this.cameraList = res.items
        this.cameraForm.total = res.totalCount
      }
    },
    // 进出楼层
    async goFloor(item) {
      // 离开
      if (this.currentFloorId === item.id) {
        this.currentFloorId = ''
        // 取消剖切效果并移动视角回到该建筑
        cloudRender.Clip.cancelClip(this.player)
        await this.moveAngle(this.buildingDetail)
        // await this.getPersonList()
        await this.getCameraList()
        this.outHandler()
        // 进入
      } else {
        this.builDingNowId = item.buildingId
        this.currentFloorId = item.id
        // await this.getPersonList()
        await this.getCameraList()
        this.nowFloor = item.name
        // 已进入的时候把最初的labelList存下来
        this.oldLabelList = cloneDeep(this.propLabelList)
        // 获取包含在楼层中的围栏
        await this.getCurrentFloorFence()
        // 发射自定义事件筛选电子围栏显示
        const filterEvent = new CustomEvent('filterElectronicList', {
          detail: {
            filterElectronicIdList: this.currentFenceIdList,
          },
        })
        window.dispatchEvent(filterEvent)
        const disableEvent = new CustomEvent('setCheckDisable', {
          detail: {
            tagList: ['BuildingList'],
            disable: true,
          },
        })
        window.dispatchEvent(disableEvent)
        // 进入楼层其他标签的处理
        this.inHandler()
        // 获取剖切参数
        await this.getclipDetail(item.sectionId)
        // 展示楼层剖切并进入视角
        await this.showArea()
        await this.moveAngle(item)
      }
    },
    // 展示剖切区域
    async showArea() {
      const min = cloneDeep(JSON.parse(this.clipDetail.minimumLocation))
      const max = cloneDeep(JSON.parse(this.clipDetail.maximumLocation))
      if (!isEmpty(min) && !isEmpty(max)) {
        const aabb = [
          [min.x, min.y, min.z],
          [max.x, max.y, max.z],
        ]
        // 通过包围盒的方式展示剖切盒子
        await cloudRender.Clip.createCilp(this.player, this.clipDataType.aabb, this.clipType.box, {
          setIsInside: this.clipDetail.clipType === 0,
          setPartCilp: false,
          aabb,
        })
        // 隐藏剖切轴和面
        await cloudRender.Clip.setVisible(this.player, 'Axis', false)
        await cloudRender.Clip.setVisible(this.player, 'Panel', false)
      }
    },
    // 切换是否隐藏按钮
    async toggleHide() {
      // 如果绑定了组态（只关心隐藏，添加组态时已经筛选）
      if (!isEmpty(this.buildingDetail.configurationId)) {
        this.isHide = !this.isHide
        if (this.isHide) {
          // 隐藏组态
          const [err, hiddenArr] = await compositeStateApi.getNeedHiddenDetails(
            this.buildingDetail.configurationId
          )
          if (!err && !isEmpty(hiddenArr)) {
            this.configurationArr = await Promise.all(
              map(hiddenArr, async (item) => {
                const info = await this.player.Native.ModelTree.findItemByName(
                  item.modelName,
                  0,
                  true,
                  3
                )
                if (!isEmpty(info)) {
                  return info.item
                }
              })
            )
            // 设置组态隐藏
            await this.setVisible(false)
          }
        } else {
          // 取消隐藏
          await this.setVisible(true)
        }
      } else {
        this.$message.warning({
          shwoClose: true,
          message: '该建筑未关联组态',
        })
      }
    },
    // 设置组态显隐
    async setVisible(type) {
      for (let i = 0; i < this.configurationArr.length; i++) {
        await cloudRender.Node.setItemStatus(this.player, this.configurationArr[i], type)
      }
    },
    // 接受到实时定位数据的处理（发送请求筛选楼层中的人员）
    async positionListHandler(e) {
      // 如果进入楼层了才开始计算
      if (!isEmpty(e?.detail?.position) && !isEmpty(this.currentFloorId)) {
        this.coordinateLocationList = cloneDeep(e.detail.position)
        this.flag = true
        await this.getCurrentFloorTag()
      }
    },
    // 进入楼层后获取在当前楼层的电子围栏
    async getCurrentFloorFence() {
      // 获取到围栏id后发送事件
      const [err, res] = await floorApi.getFloorAllFences({
        floorIds: [this.currentFloorId],
        modelId: this.customProps?.sceneId,
      })
      if (!err && !isNil(res)) {
        this.currentFenceIdList = map(res, (item) => {
          return item.fenceId
        })
      }
    },
    // 进入楼层后获取在当前楼层的人员
    async getCurrentFloorTag() {
      // 如果没有进入楼层，则不筛选人员
      if (!this.flag || isEmpty(this.currentFloorId)) {
        return
      }
      if (!isEmpty(this.coordinateLocationList)) {
        this.flag = false
        const [err, res] = await floorApi.getCoordinateLocationFloor({
          body: {
            coordinateLocationList: this.coordinateLocationList,
            floorIds: [this.currentFloorId],
            modelId: this.customProps?.sceneId,
          },
        })
        this.flag = true
        if (!err && !isNil(res)) {
          // 发射自定义事件筛选实时人员标签显示
          const filterEvent = new CustomEvent('filterPositionList', {
            detail: {
              tagIdList: flatten(
                map(res, (item) => {
                  return item.tagIds
                })
              ),
              isInfloor: true,
            },
          })
          window.dispatchEvent(filterEvent)
        }
      }
    },
    // 进入楼层其他标签的变化
    inHandler() {
      // 只显示人员和电子围栏
      const newLabelList = map(this.oldLabelList, (item) => {
        // 如果一进来电子围栏和人员标签是打开的，则不要关闭
        if ((item.code === 'ElectronicFence' || item.code === 'PersonnelList') && item.checked) {
          return {
            ...item,
            checked: true,
          }
        }
        return {
          ...item,
          checked: false,
        }
      })
      const hiddenList = filter(this.oldLabelList, (item) => {
        return item.checked
      })
      const hiddenEvent = new CustomEvent('setComponentVisible', {
        detail: {
          type: 'hidden',
          hiddenList,
          newLabelList,
        },
      })
      window.dispatchEvent(hiddenEvent)
    },
    // 退出楼层其他标签的变化
    outHandler() {
      // 获取目前已经打开的标签数组（除了围栏和人员）
      const openCodeList = map(
        filter(this.propLabelList, (item) => {
          return item.checked
        }),
        (i) => {
          return i.code
        }
      )
      // 对比目前已经打开和进入楼层时打开的标签
      // 得到需要重新打开的标签的数组
      const displayLabelList = filter(this.oldLabelList, (item) => {
        // 在进入后被关闭的标签需要重新显示
        if (
          !some(openCodeList, (i) => {
            return i === item.code
          }) &&
          item.checked
        ) {
          return true
        }
        if (
          // 电子围栏或者人员再打开的则也需要取消筛选功能
          some(openCodeList, (i) => {
            return i === item.code
          }) &&
          (item.code === 'ElectronicFence' || item.code === 'PersonnelList')
        ) {
          return true
        }
      })
      // 得到当前应该还原的labelList，给labelList重新赋值
      const newLabelList = map(this.oldLabelList, (item) => {
        // 进入楼层之后手动打开的和进入楼层时就是打开的
        if (
          some(openCodeList, (i) => {
            return i === item.code
          }) ||
          item.checked
        ) {
          return {
            ...item,
            checked: true,
          }
        }
        return {
          ...item,
          checked: false,
        }
      })
      const displayEvent = new CustomEvent('setComponentVisible', {
        detail: {
          type: 'display',
          displayLabelList,
          newLabelList,
        },
      })
      window.dispatchEvent(displayEvent)
    },
  },
  beforeDestroy() {
    // 解绑事件
    window.removeEventListener('setPositionList', this.positionListHandler)
    if (this.moveTimer) {
      clearTimeout(this.moveTimer)
      this.moveTimer = null
    }
    // 如果进入楼层了
    if (!isEmpty(this.currentFloorId)) {
      this.outHandler()
    }
    // 取消剖切
    cloudRender.Clip.cancelClip(this.player)
    // 取消组态隐藏
    this.setVisible(true)
  },
}
</script>

<style lang="scss" scoped>
.head-bg {
  background: url('../../assets/images/control/table_head.png');
  background: var(--tableHeadBg);
  background-size: 100% 100%;
}

.circle {
  background: url('../../assets/images/title_back_mid.png');
  background-size: 100% 100%;
}

.table-choosed {
  background: url('../../assets/images/control/table_choosed.png');
  background-size: 100% 100%;
}

.area-box {
  &::-webkit-scrollbar {
    background-color: transparent;
    width: 9px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #104a70;
    color: #104a70;
  }
}
</style>
